import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import useModal, { MODAL_md } from "../../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../../theme/Component/Modal";
import { _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { ConcepItem } from "../ConcepItem";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";
import { InputMoney } from "../../../../../../theme/Input/InputMoney";
import { toast } from "react-toastify";

interface Props {
    listParameters: any;
    functionModalEvent: Function;
    value: any;
    onChange?: Function;
    DataPayd?: any;
}

export const ComponentSettedDistributionValues = forwardRef(({ functionModalEvent, value, listParameters, onChange, DataPayd }: Props, ref) => {

    const modalDistribucion = useModal("Distribución", MODAL_md);
    const [diferencia, setDiferencia] = useState<number>(0);
    const [concept, setConcept] = useState<any>([]);
    const [obs, setObs] = useState<string>("");

    useEffect(() => {
        setConcept(listParameters)
    }, [listParameters])

    const openModal = () => {
        modalDistribucion.open();
    }

    const closeModal = () => {
        modalDistribucion.close();
    }

    useImperativeHandle(ref, () => ({
        openModal, closeModal,
    }));

    useEffect(() => {
        if (!listParameters) return;

        const movementsMap: Record<number, number> = {};
        value?.Movements?.forEach((mov: any) => {
            movementsMap[mov.Type] = mov.Value;
        });

        setObs(`${value.Description ?? ""}`)

        const derivedConcepts = listParameters.map((row: any) => {
            return {
                ...row.DataBeanProperties,
                AppliedValue: movementsMap[row.DataBeanProperties.Type] ?? 0,
            };
        });

        setConcept(derivedConcepts);

    }, [listParameters, value]);

    useEffect(() => {
        const total = concept.reduce((acc: number, curr: any) => acc + (curr.AppliedValue || 0), 0);
        const diff = DataPayd?.VrCuota ? DataPayd.VrCuota - total : 0;

        setDiferencia(diff);

        if (diff !== 0) return;

        const newMovements = concept
            .filter((c: any) => (c.AppliedValue || 0) > 0)
            .map((c: any) => ({
                Type: c.Type,
                Value: c.AppliedValue
            }));

        const response = {
            ...value,
            Description: obs,
            Movements: newMovements,
        };

        onChange?.(response);
    }, [concept, DataPayd, obs]);



    return (
        <Modal modal={modalDistribucion.modal} updateModal={modalDistribucion.setModal} eventModal={() => {
            if (diferencia) {
                toast.error("Debe asignar el valor completo")
            } else {
                functionModalEvent?.()
            }
        }
        } onSubmitLabel="Aplicar Pago" >
            <div className="row">
                <div className="col-md-12 d-flex justify-content-start">
                    <strong style={{ marginRight: "6px" }}>Valor Descuento/Pago </strong>
                    <small dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(DataPayd.VrCuota, 2) }} />
                </div>
                <div className="col-md-12 d-flex justify-content-start">
                    <strong>Diferencia: </strong>
                    <span style={{ color: diferencia === 0 ? "green" : "red" }} dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(diferencia, 2) }} ></span>
                </div>
                {concept.map((row: any, index: number) => (
                    <div className="row" key={index}>
                        <div className="col-6 mt-4">
                            <strong>{row.Name} ({row.Type})</strong><br />
                            <small>{row.TypeName}</small>
                        </div>
                        <div className="col-6">
                            <InputMoney
                                _value={row.AppliedValue}
                                onChange={(newValue: number) => {
                                    const prevValue = concept[index].AppliedValue || 0;

                                    const updated = [...concept];
                                    updated[index] = { ...updated[index], AppliedValue: newValue };

                                    setConcept(updated);
                                }}
                            />

                        </div>
                    </div>
                ))}
                <div className="col-md-12">
                    <label>Observaciones</label>
                    <textarea value={obs} onChange={(e) => { setObs(e.target.value) }} className="form-control" />
                </div>
            </div>
        </Modal >
    )
})